import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'screen-cell-simple,screen-cell[simple]',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.less']
})
export class CellComponent implements AfterViewInit {

  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit() {

  }

}
